// Pushes app events to the GTM dataLayer (container loaded in public/index.html).
// Every event carries the current user context, so GTM variables can read
// user_id / plan state without each call site repeating them.

// Console tracing for dataLayer pushes. Flip to false to silence it.
const DATALAYER_DEBUG = true;

const getUserContext = () => {
  const user_id = localStorage.getItem('dastaan__user_id');
  return {
    user_id: user_id || null,
    logged_in: !!localStorage.getItem('dastaan__token'),
    plan_id: localStorage.getItem('dastaan__plan_id') || null,
    plan_active: localStorage.getItem('dastaan__plan_active') === 'true',
  };
};

/**
 * Fire-and-forget: tracking must never throw into the calling flow.
 */
export const pushEvent = (event, params = {}) => {
  try {
    window.dataLayer = window.dataLayer || [];
    // GA4: clear the previous ecommerce object so its items don't merge into this one.
    if (params.ecommerce) window.dataLayer.push({ ecommerce: null });
    const payload = { event, ...getUserContext(), ...params };
    window.dataLayer.push(payload);
    if (DATALAYER_DEBUG) console.log('🏷️ [dataLayer]', payload);
  } catch (e) {
    // ignore
  }
};

// Event names in one place so GTM triggers and code never drift apart.
export const EVENTS = {
  PAGE_VIEW: 'page_view',
  OTP_REQUEST: 'otp_request',
  OTP_RESEND: 'otp_resend',
  LOGIN: 'login',
  LOGIN_FAILED: 'login_failed',
  LOGOUT: 'logout',
  CONTENT_CLICK: 'content_click',
  SEARCH: 'search',
  AUDIO_PLAY: 'audio_play',
  AUDIO_PAUSE: 'audio_pause',
  AUDIO_RESUME: 'audio_resume',
  AUDIO_PROGRESS: 'audio_progress',
  AUDIO_COMPLETE: 'audio_complete',
  AUDIO_CLOSE: 'audio_close',
  VIEW_PLANS: 'view_item_list',
  SELECT_PLAN: 'select_item',
  BEGIN_CHECKOUT: 'begin_checkout',
  PURCHASE: 'purchase',
  SUBSCRIPTION_CANCEL: 'subscription_cancel',
};
